// extracted by mini-css-extract-plugin
module.exports = {"noHover":"Table_noHover__ucLp0"};